import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; // Import the CSS file

const BodyCenterText= ({ text, color }) => {
  return (
    <p className="body-center-text" style={{ color: color }}>
      {text}
    </p>
  );
};

BodyCenterText.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodyCenterText;